enum ModalsEnum {
  'portfolio_modal.add_to_your_portfolio' = 'portfolio_modal.add_to_your_portfolio',
  'portfolio_modal.add_to_portfolio' = 'portfolio_modal.add_to_portfolio',
  'portfolio_modal.price_you_paid' = 'portfolio_modal.price_you_paid',
  'portfolio_modal.type_price' = 'portfolio_modal.type_price',
  'portfolio_modal.amount' = 'portfolio_modal.amount',
  'portfolio_modal.purchase_date' = 'portfolio_modal.purchase_date',
  'portfolio_modal.adding_bottle_to_portfolio' = 'portfolio_modal.adding_bottle_to_portfolio',
  'portfolio_modal.success_adding_bottle_to_portfolio' = 'portfolio_modal.success_adding_bottle_to_portfolio',
  'portfolio_modal.error_adding_bottle_to_portfolio' = 'portfolio_modal.error_adding_bottle_to_portfolio',
  'portfolio_modal.invalid_amount' = 'portfolio_modal.invalid_amount',
  'portfolio_modal.invalid_date' = 'portfolio_modal.invalid_date',
  'portfolio_modal.invalid_price' = 'portfolio_modal.invalid_price',
  'onboarding_modal.welcome_to_spiritory' = 'onboarding_modal.welcome_to_spiritory',
  'onboarding_modal.content_step_one_1' = 'onboarding_modal.content_step_one_1',
  'onboarding_modal.content_step_one_2' = 'onboarding_modal.content_step_one_2',
  'onboarding_modal.skip' = 'onboarding_modal.skip',
  'onboarding_modal.only_skip' = 'onboarding_modal.only_skip',
  'onboarding_modal.dont_show_me_this_again' = 'onboarding_modal.dont_show_me_this_again',
  'onboarding_modal.next' = 'onboarding_modal.next',
  'onboarding_modal.get_the_best_out_of_spiritory' = 'onboarding_modal.get_the_best_out_of_spiritory',
  'onboarding_modal.would_you_like_to_buy_or_sell_whisky_or_spirits' = 'onboarding_modal.would_you_like_to_buy_or_sell_whisky_or_spirits',
  'onboarding_modal.create_a_buyer_account' = 'onboarding_modal.create_a_buyer_account',
  'onboarding_modal.create_a_seller_account' = 'onboarding_modal.create_a_seller_account',
  'onboarding_modal.i_just_want_to_explore_for_now' = 'onboarding_modal.i_just_want_to_explore_for_now',
}

export { ModalsEnum };